import React, { useRef, useState } from "react";
import styles from "./Content.module.css";

function Content({ key, title, videoUrl, posterUrl }) {
  return (
    <>
      <div className={`${styles.content}`} key={key}>
        <iframe
          width="300"
          max-width="fit-content"
          height="171"
          src={videoUrl}
          title={title}
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen></iframe>

        {title}
      </div>
    </>
  );
}

export default Content;
